module.exports = __webpack_public_path__ + "img/service_4.b95ac2f1.png";